import { render, staticRenderFns } from "./boutique_infos.vue?vue&type=template&id=4c532124&scoped=true&"
import script from "./boutique_infos.vue?vue&type=script&lang=js&"
export * from "./boutique_infos.vue?vue&type=script&lang=js&"
import style0 from "./boutique_infos.vue?vue&type=style&index=0&id=4c532124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c532124",
  null
  
)

export default component.exports